import { App as AntdApp, Button, Card, Form, Input } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { loginRequest, logout } from '@/AppRedux/actions/auth';
import { useAppSelector } from '@/AppRedux/store/hooks';
import { useEffect, useRef, useState } from 'react';

export default function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { message } = AntdApp.useApp();
  const { user, loading, error } = useAppSelector((state) => state.auth);
  const [hintPassword, setHintPassword] = useState('1234');

  const isDev = import.meta.env?.DEV || false;

  const fromUrl = '/';
  const { propcode } = useParams<{ propcode: string }>();

  const urlFirstLoad = useRef(true)

  if(urlFirstLoad.current) {
    urlFirstLoad.current = false
    if(error) {
      dispatch(logout()) // เคลียร์ error เดิมถ้ามี
    }
  }

  const onFinish = (values: { username: string; password: string }) => {
    dispatch(loginRequest(values.username, values.password , propcode || ''));
  };

  useEffect(() => {
    if (user) {
      message.success(`Logged in as ${user.role}`);
      if (user.role === 'admin' || user.role === 'superAdmin') {
        const fromAdmin = `/administrator/${propcode}/admin`;
        navigate(fromAdmin, { replace: true });
      } else {
        navigate(fromUrl, { replace: true });
      }
    }
  }, [user, navigate, fromUrl, message]);

  useEffect(() => {
    const calculatePassword = () => {
      const now = new Date();
      const hour = String(now.getHours()).padStart(2, '0');
      const minute = String(now.getMinutes()).padStart(2, '0');
      setHintPassword(`admin@${hour}${minute}`);
    };

    calculatePassword();

    // ตั้ง Interval update ทุกนาที เผื่อเปิดหน้าจอนี้ค้างไว้ข้ามชั่วโมง
    const interval = setInterval(calculatePassword, 60000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{ display: 'grid', placeItems: 'center', minHeight: '60vh' }}>
      <Card title="Sign In" style={{ width: 360 }}>
        <Form layout="vertical" onFinish={onFinish}>
          <Form.Item name="username" label="Username" rules={[{ required: true }]}>
            <Input placeholder="admin" />
          </Form.Item>
          <Form.Item name="password" label="Password" rules={[{ required: true }]}>
            <Input.Password placeholder={isDev ? hintPassword : "password"} />
          </Form.Item>
          <Button type="primary" htmlType="submit" block loading={loading}>Login</Button>
          {error && <p style={{ color: 'red' }}>{error}</p>}
        </Form>
      </Card>
    </div>
  );
}
